import React from 'react';
import {connect} from 'react-redux';
import PropTypes from "prop-types";
import {addAdditionalIndicator, removeAdditionalIndicator} from "../../actions/indicators";
import LocaleUtils from "qwc2/utils/LocaleUtils";
import IndicatorUtils from "../../utils/IndicatorUtils";

class MultiIndicatorList extends React.Component {
    static propTypes = {
        addAdditionalIndicator: PropTypes.func,
        additionalIndicators: PropTypes.array,
        indicators: PropTypes.array,
        removeAdditionalIndicator: PropTypes.func,
        selectedObjectType: PropTypes.string,
    }
    static defaultProps = {}

    constructor(props) {
        super(props);

        this.state = {
            newIndicator: '',
            newTime: '',
            data: {},
            isLoading: true,
            url: null,
        };
    }


    render() {
        const newIndicators = [];
        const newTimes = [];
        this.props.indicators.forEach(i => {
            if (i.indicatorValueObjectTypes.indexOf(this.props.selectedObjectType) > -1) {
                newIndicators.push(i);
            }
            if (i.id == this.state.newIndicator) {
                if (i.timeSlices) {
                    i.timeSlices.forEach(ts => newTimes.push(ts));
                }
            }
        });

        return (
            <div className="indicators-additionallist">
                <strong>{LocaleUtils.tr('indicators.compareindicators')}</strong>
                {this.props.additionalIndicators.map(indiTime => {
                    return (
                        <div key={'indadd' + indiTime.indicator.id + '-' + indiTime.time}>
                            <span>
                                {indiTime.indicator.name}
                            </span>
                            <span>
                                {IndicatorUtils.normalizeDate(indiTime.time)}
                            </span>
                            <span className="icon icon-trash" onClick={() => this.props.removeAdditionalIndicator(indiTime)}></span>
                        </div>
                    );
                })}
                <div className="indicators-additionallist-add">
                    {this.renderIndicatorSelector(newIndicators)}
                    {this.renderTimeSelector(newTimes)}
                    {this.renderAdd(newTimes)}
                </div>
            </div>
        );
    }

    add() {
        this.props.indicators.forEach(i => {
            if (i.id == this.state.newIndicator) {
                this.props.addAdditionalIndicator({
                    indicator: i,
                    time: '' + this.state.newTime
                });
                this.setState({newIndicator: '', newTime: ''});
                return;
            }
        });
    }

    renderAdd(newTimes) {
        if (newTimes.length == 0) {
            return null;
        }
        if (this.state.newIndicator && this.state.newTime) {
            return (
                <button className="button" onClick={() => this.add()}>{LocaleUtils.tr('indicators.addadditional')}</button>
            );
        }
        return null;
    }

    renderTimeSelector(newTimes) {
        if (newTimes.length == 0) {
            return null;
        }
        return (
            <select value={this.state.newTime}
                    onChange={ev => this.setState({newTime: ev.target.value})}>
                {newTimes.map(item => {
                    return (
                        <option key={item}
                                value={item}>{IndicatorUtils.normalizeDate(item)}</option>
                    );
                })}
            </select>
        );
    }

    selectIndicator(ev) {
        const newIndi = ev.target.value;
        let newTime = null;
        this.props.indicators.forEach(i => {
            if (i.id == newIndi) {
                if (i.timeSlices && i.timeSlices[0]) {
                    newTime = i.timeSlices[0];
                }
            }
        });

        this.setState({
            newIndicator: newIndi,
            newTime: newTime
        });
    }

    renderIndicatorSelector(newIndicators) {
        return (
            <select value={this.state.newIndicator}
                    onChange={ev => this.selectIndicator(ev)}>
                <option key="-" value="">-</option>
                {newIndicators.map(item => {
                    return (
                        <option key={item.id}
                                value={item.id}>{item.name}</option>
                    );
                })}
            </select>
        );
    }
}

const selector = (state) => ({
    selectedObjectType: state.indicators.selectedObjectType,
    indicators: state.indicators.indicators,
    additionalIndicators: state.indicators.additionalIndicators,
});

export default connect(selector, {
    addAdditionalIndicator: addAdditionalIndicator,
    removeAdditionalIndicator: removeAdditionalIndicator,
})(MultiIndicatorList);
